/** Представление списка элементов http://www.w3.org/ns/adms#AssetDistribution.
 * Для http://www.w3.org/ns/adms#Asset элементы задаются в http://www.w3.org/ns/dcat#distribution
 *
 *  Для отображения используется List (см. https://ant.design/components/list/),который содержит:
 * 1. Заголовок - заголовок AssetDistribution (см. http://purl.org/dc/terms/title)
 * 2. Описание - Описание  (см. http://purl.org/dc/terms/description)
 * 
 * 3. Входным параметром является массив distribution[], содержащий URI элементов
 * 
 */
import React from 'react';
import { connect } from 'react-redux'
import { List, Button, Modal, message } from 'antd';
import i18n from "i18next";
import { subsetByLang, getLangValue, updateTripletsByObjectValue } from '../../virtuoso/helper';
import {AssetDistributionListItem} from './AssetDistributionSmall';
import AssetDistributionCard from './AssetDistributionCard';
import { AdmsAsset, RdfTriplet } from '../../redux';
import { DMLActions } from '../../redux';
import FileSelectPage from '../dml/FileSelectPage';

const { confirm } = Modal;

const showViewDetail = (formRef=f=>f, selected, factory, history, onFinishOperation=f=>f, onCancelOperation=f=>f) => {
	//console.log("syncPercent", selected, factory, history);
	return <Modal style={{minWidth: "80%"}} visible={true} 
          title={i18n.t('components.adms.distribution.show.title')}
          cancelText={i18n.t('components.adms.distribution.show.cancelText')}
          okText={i18n.t('components.adms.distribution.show.okText')} 
          onCancel={onCancelOperation} onOk={onFinishOperation}	cancelButtonProps={{ disabled: true, dispaly: "none" }}>
      <AssetDistributionCard IRI={selected} factory={factory} history={history}/>
 	  </Modal>
}

const showAdd = (formRef=f=>f, onFinishOperation=f=>f, onCancelOperation=f=>f, selected) => {
  //console.log("syncPercent", syncPercent);
  const isFile = (selected) && (selected.fileEntryId);
  const okButtonProps={disabled: !isFile};
	return 
    <Modal style={{minWidth: 700}} visible={true} 
        title={i18n.t('components.adms.distribution.add.title')}
        cancelText={i18n.t('components.adms.distribution.add.cancelText')}
        okText={i18n.t('components.adms.distribution.add.okText')} 
        onCancel={onCancelOperation} onOk={onFinishOperation} okButtonProps={okButtonProps}>	
      <FileSelectPage wrappedComponentRef={formRef} />
	  </Modal>
}

/** 
 * Отображение распротранение элемента каталога.
 * */
class AssetDistributions extends React.Component {
  state = {
    loading: false,
    wikies: [],
  }
  
  modalFormRef = formRef => {
    this.formRef = formRef;
  }

  componentDidMount() {
    this.loadDetails();
  }

  /** Необходимо понять, наличие детальной информации о распространение актива.
   * Первоначально загружается только ссылка на distribution, нужно дять детальную информацию
   */
  componentWillReceiveProps(nextProps){
    const {distributions} = nextProps;
    //Есть незагруженное описания распространения актива
    if (distributions && Array.isArray(distributions) && (distributions.filter(d=> d.state!="loaded").length>0))
      this.loadDetails(distributions);
  }

  loadDetails(items=null) {
    const {distributions, lang, graph, onLoadDetailDistribution} = this.props;
    this.setState({loading: true});
    const values = (items)?items:distributions;
    //Получаем список ссылок
    const data = subsetByLang(values, lang);
    const requests = data.map(distribution => RdfTriplet.loadSubject(distribution.object.value, graph));
    //Получим описание всех элементов и обновим distributions
    Promise.all(requests).then(result => {
       result.forEach(distribution => {
          //определим исходный источник, т.к. нужно указать в параметрах lang, для которого нужно сделать обновление
          const sources = data.filter(item => item.object.value == distribution.subject);
          const findLang = (sources && (sources.length>0))? getLangValue(sources[0]): undefined;
          updateTripletsByObjectValue({values: distribution.bindings, state: "loaded"}, values, distribution.subject, findLang);
       });
       onLoadDetailDistribution(AdmsAsset, values);
       this.setState({loading: false});
    }).catch( e => {
      data.forEach(distribution => {
        updateTripletsByObjectValue({state: "error"}, values, distribution.object.value);
      });
      onLoadDetailDistribution(AdmsAsset, values);
      this.setState({loading: false});
      message.error(i18n.t('components.adms.distribution.message.e_detail', {detail: e}));//`Ошибка при получении дополнительной информации и распространении элемента каталога. ${e}`)
    })
  };
    
  handleDetailDistribution (e, IRI) {
    console.log("AssetDistributions.js", this, IRI);
    e.preventDefault();
    this.setState({modal:"view", selected: IRI});
  };

  /** Удаление Distribution */
  handleDeleteDistribution (e, IRI, header) {
    e.preventDefault();
    //console.log("handleDeleteDistribution (e, IRI)", IRI, e);
    const { asset, onDeleteElement } = this.props;
    confirm({ title: i18n.t('components.adms.distribution.unlink.title'), content: header, 
    okText: i18n.t('components.adms.distribution.unlink.okText'), okType: 'danger', 
    cancelText: i18n.t('components.adms.distribution.unlink.cancelText'),
      onOk() { 
        onDeleteElement(AdmsAsset, asset, IRI)
          .then (result =>{
              //console.log("onDeleteElement", result);
              message.success(i18n.t('components.adms.distribution.message.ok_unlink'));
          })
      },
      onCancel() {},
    });
//this.setState({modal:"view", selected: IRI});
  };

  cancelOperation(){
    this.setState({modal:"none"});
  }

  /** Запускает добавление нового  */
  submitOperation() {
    //console.log('submitOperation() ', this.props.selected);
    const { asset, lang, selected, onAddElement} = this.props;
    const IRI = asset+"_distribution_"+selected.fileEntryId;
    const url = encodeURI("http://62.61.8.56:8080/documents/"+selected.groupId+"/"+selected.folderId+"/"+selected.fileName+"/"+selected.uuid);
    onAddElement(AdmsAsset, asset, IRI, selected.title, selected.description, '"'+url+'"', lang)
      .then (result =>{
          //console.log("onAddElement", result);
          message.success(i18n.t('components.adms.distribution.unlink.ok_link'));
        })
    this.setState({modal:"none"});
  };

  onAction (e, type, item) {
    e.preventDefault();
    //console.log("onAction (e, type, item)", e, type, item);
    this.props.onLoadItems()
      .then(response => {
        //console.log("result", response);
        this.setState({modal:"add"});
      })
      .catch(e => {
        message.error(i18n.t('components.adms.distribution.message.e_search', {detail: e}));//`Ошибка при поиске файлов. ${e}`); 
      });
  };

  render() {
    //console.log(this);
    const { modal, loading, selected } = this.state;
    const { distributions, factory, history } = this.props;
    const hasDistribution = (distributions && Array.isArray(distributions) && distributions.length>0);
    const isModified = this.props.operation == "edit";
    return (
      <span>
        {isModified && <div class="ant-btn-group" style={{background: "rgb(128, 128, 128)"}}><Button type="dashed" size="small" icon="edit" ghost onClick={(e)=> this.onAction(e, "add")}>Связать</Button></div>}
        {(modal=="add" )&& showAdd( this.saveFormRef, ()=>this.submitOperation(), ()=>this.cancelOperation(), this.props.selected)}
        {!hasDistribution &&
          <ul class="ant-list-items">
            <li class="ant-list-item">
              <div class="ant-list-item-meta">
                <div class="ant-list-item-meta-content">
                  <h4 class="ant-list-item-meta-title"><span class="csi_cat_title">{i18n.t('components.adms.distribution.title')}</span></h4>
                  <h4 class="ant-list-item-meta-title"><b>{i18n.t('components.adms.distribution.nolinks')}</b><br />{i18n.t('components.adms.distribution.nofiles')}</h4>
                </div>
              </div>
            </li>
          </ul> 
        }
        {hasDistribution && 
          <ul class="ant-list-items">
            <li class="ant-list-item" style={{borderBottomRightRadius: 0, borderBottomLeftRadius: 0}}>
              <div class="ant-list-item-meta">
                <div class="ant-list-item-meta-content">
                  <h4 class="ant-list-item-meta-title"><span class="csi_cat_title">{i18n.t('components.adms.distribution.title')}</span></h4>
                </div>
              </div>
            </li>
            {distributions.map(item => 
                    <AssetDistributionListItem 
                      distribution={item} factory={factory} 
                      onClick={(e, iri) => this.handleDetailDistribution(e, iri)}
                      onDelete={(e, iri, header) => this.handleDeleteDistribution(e, iri, header)}
                      canDeleted={isModified}
                    />
                  )}
        </ul> 
        }
        {(modal=="view" )&& showViewDetail(this.modalFormRef, selected, factory, history, ()=>this.cancelOperation(), ()=>this.cancelOperation())}
        </span>
    );
  }
}

/* <List className="demo-loadmore-list" loading={loading} itemLayout="horizontal"
dataSource={distributions}
renderItem={
  item => <AssetDistributionListItem 
            distribution={item} factory={factory} 
            onClick={(e, iri) => this.handleDetailDistribution(e, iri)}
            onDelete={(e, iri, header) => this.handleDeleteDistribution(e, iri, header)}
            canDeleted={isModified}
          />
}
/> */

//Представление списка AssetDistribution
export default connect(
  (state, props) => {
    const {vset, vasset, ldml} = state;
    const {lang, graph } = props;
    return ({
      lang: (lang)?lang: vset.lang,
      graph: (graph)?graph: vset.graph,
      distributions: vasset.distributions,      //Текущие данные
      asset:  vasset.iri,
      selected: ldml.file,
    })
  },
  dispatch => ({
    onAddElement (actions, asset, iri, label, description, url, lang){
      return dispatch(actions.addDistribution(asset, iri, label, description, url, lang));
    },
    onDeleteElement (actions, asset, iri){
      return dispatch(actions.deleteDistribution(asset, iri));
    },
    onLoadDetailDistribution (actions, values){
      return dispatch(actions.LOAD_DISTRIBUTIONS(values));
    },
    onLoadItems(){
      return dispatch(DMLActions.loadItems());
    },
  })
)(AssetDistributions)
